import { PartialNullable } from "../../Extensions";
import { Property } from "../../RadObject";
import { ITableColumnBase, TableColumnBase, TableColumnBasePropertyValues } from "./Table";
import { TableCellEntitySaveIndicator } from "./TableCellEntitySaveIndicator";
import { NAMESPACE } from "./_Namespace";

export type TableColumnEntitySaveIndicatorPropertyValues =
    TableColumnBasePropertyValues
    & {
    };

export type TableColumnEntitySaveIndicatorProperties = {
    [name in keyof TableColumnEntitySaveIndicatorPropertyValues]: Property<TableColumnEntitySaveIndicatorPropertyValues[name]>
};

export interface ITableColumnEntitySaveIndicator extends ITableColumnBase, TableColumnEntitySaveIndicatorProperties
{
}

export class TableColumnEntitySaveIndicator extends TableColumnBase implements ITableColumnEntitySaveIndicator
{
    // #region Static

    public static override classNamespace = NAMESPACE + "TableColumnEntitySaveIndicator";
    public static override className = "TableColumnEntitySaveIndicator";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<TableColumnEntitySaveIndicatorPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                tableCellClass: TableCellEntitySaveIndicator,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<TableColumnEntitySaveIndicatorPropertyValues>)
    {
        super(propertyValues);

        this.addCssClass("rad-control-table-column-entity-save-indicator");
    }

    // #endregion

    // #endregion
}

